import { jsx, jsxs } from 'react/jsx-runtime';
import { DelayedContent, useDelayedContent } from '@flex-design-system/fx-extension';
import { Suspense } from 'react';

const DelayedSuspense = ({ fallbackConfig, ...rest }) => {
  return /* @__PURE__ */ jsx(
    DelayedContent,
    {
      delayTime: fallbackConfig?.delayTime ?? 200,
      minDisplayTime: fallbackConfig?.minDisplayTime ?? 300,
      children: /* @__PURE__ */ jsx(DelayedSuspenseInner, { ...rest })
    }
  );
};
const DelayedSuspenseInner = ({
  children,
  pending = false,
  fallback,
  ...rest
}) => {
  const { isShow } = useDelayedContent();
  return /* @__PURE__ */ jsxs(
    Suspense,
    {
      fallback: /* @__PURE__ */ jsx(DelayedContent.Delay, { children: fallback }),
      ...rest,
      children: [
        (isShow || pending) && /* @__PURE__ */ jsx(ShowFallback, {}),
        children
      ]
    }
  );
};
const ShowFallback = () => {
  throw new Promise(() => {
  });
};

export { DelayedSuspense as default };
//# sourceMappingURL=index.mjs.map
